import React, { memo, forwardRef } from "react";
const SvgCapitalL = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.64 10.25c0-.293.047-.533.14-.72.094-.187.2-.333.32-.44a.94.94 0 01.42-.2c.147-.04.274-.06.38-.06.107 0 .233.02.38.06.147.027.28.093.4.2.133.107.247.253.34.44.094.187.14.427.14.72v10.68h4.98c.267 0 .48.04.64.12.16.08.28.18.36.3.093.12.154.247.18.38.027.12.04.227.04.32s-.013.207-.04.34a.912.912 0 01-.18.36c-.08.12-.2.22-.36.3-.16.08-.373.12-.64.12h-6c-1 0-1.5-.5-1.5-1.5V10.25z"
      />
    </svg>
  );
});
SvgCapitalL.displayName = "SvgCapitalL";
const MemoForwardRef = memo(SvgCapitalL);
export default MemoForwardRef;
